import React from 'react';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';

const PrivateLessonsOverview = () => {
  return (
    <>
      <div className='p-5 lg:p-12 bg-waves bg-cover lg:px-36 min-h-screen space-y-3 lg:grid grid-cols-2'>
        <div>
          <motion.div
            animate={{ x: 0 }}
            initial={{ x: -500 }}
            transition={{ delay: 0.1 }}
          >
            <h3 className='text-black mb-4 text-4xl font-bold lg:text-left md:text-center lg:pl-12'>
              Private Academic Lessons Overview
            </h3>
          </motion.div>
          <div className='lg:py-4 lg:pr-12'>
            <div className='bg-white p-6 rounded-lg shadow-lg text-left flex'>
              <p className='text-black sm:text-justify md:text-xl'>
                Link and Learn Academy’s private customized 1 on 1 lessons are
                led by one of the highly experienced teachers on our pedagogical
                team. After providing a free academic assessment to determine
                the student’s strengths, weaknesses, academic needs and persona,
                the teacher will custom build a curriculum specifically for each
                student to help them overcome their deficits while also
                accelerating their learning in areas that they are naturally
                stronger in. No two students are taught with the same
                curriculum.
              </p>
            </div>
          </div>
        </div>
        <div className='lg:pr-12'>
          <img
            className='sm:mx-auto h-auto rounded-3xl drop-shadow-2xl 2xl:mt-9 lg:mt-24'
            src='/teaching1.png'
            alt=''
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivateLessonsOverview;
